(() => {
  'use strict';
  const roots = document.querySelectorAll('[data-f2w-organization-detail]');
  const query = `query OrganizationEvents($after: String, $language: LanguageCode!) @inContext(language: $language) {
    metaobjects(type: "event", first: 100, after: $after) {
      nodes { id onlineStoreUrl
        name: field(key: "name") { value }
        dateStart: field(key: "date_start") { value }
        dateEnd: field(key: "date_end") { value }
        historic: field(key: "is_historic") { value }
        image: field(key: "resolved_image_url") { value }
        cityReference: field(key: "city_reference") { reference { ... on Metaobject { name: field(key: "name") { value } } } }
        organization: field(key: "organization") { value reference { ... on Metaobject { id } } }
      }
      pageInfo { hasNextPage endCursor }
    }
  }`;
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const dayInAmsterdam = () => {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const get = type => parts.find(part => part.type === type)?.value;
    return `${get('year')}-${get('month')}-${get('day')}`;
  };
  const category = (event, today) => {
    if (['true', '1'].includes(String(event.historic?.value || '').toLowerCase())) return 'historic';
    const date = String(event.dateEnd?.value || event.dateStart?.value || '').slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return '';
    return date >= today ? 'upcoming' : 'past';
  };
  const groupRank = { upcoming: 0, past: 1, historic: 2 };
  const sortEvents = (a, b) => groupRank[a.group] - groupRank[b.group]
    || (a.group === 'upcoming' ? a.date.localeCompare(b.date) : b.date.localeCompare(a.date))
    || a.name.localeCompare(b.name);
  const normalizeUrl = value => {
    try { const url = new URL(value, window.location.origin); return url.pathname + url.search; }
    catch (_) { return ''; }
  };
  const referenceId = value => String(value || '').split('/').pop();
  roots.forEach(root => {
    if (root.dataset.f2wOrganizationInitialized === 'true') return;
    root.dataset.f2wOrganizationInitialized = 'true';
    const sections = [...root.querySelectorAll('[data-f2w-organization-events]')];
    if (!sections.length) return;
    const locale = root.dataset.language || 'nl';
    const language = locale.split('-')[0].toUpperCase();
    const counter = new Intl.NumberFormat(locale);
    const labels = { upcoming: root.dataset.eventsUpcoming, past: root.dataset.eventsPast, historic: root.dataset.eventsHistoric };
    const existingImages = new Map(sections.flatMap(section => [...section.querySelectorAll('a.fd-event-card')]).map(card => [normalizeUrl(card.href), card.querySelector('img')?.src || '']));
    const organizationId = referenceId(root.dataset.organizationId);
    const directIds = new Set((root.dataset.directEventIds || '').split(',').map(id => referenceId(id.trim())).filter(Boolean));
    let sharedRequest = null;
    const loadEvents = () => {
      if (!sharedRequest) {
        sharedRequest = (async () => {
        const token = root.dataset.storefrontToken;
        const domain = root.dataset.shopDomain;
        if (!token || !domain || !root.dataset.organizationId) throw new Error('Missing Storefront configuration');
        const matched = new Map(); const seenCursors = new Set();
        let after = null;
        while (true) {
          const response = await fetch(`https://${domain}/api/2024-10/graphql.json`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token }, body: JSON.stringify({ query, variables: { after, language } }) });
          if (!response.ok) throw new Error('Events request failed');
          const result = await response.json();
          const connection = result.data?.metaobjects;
          if (result.errors?.length || !Array.isArray(connection?.nodes) || typeof connection.pageInfo?.hasNextPage !== 'boolean') throw new Error('Incomplete Events response');
          for (const event of connection.nodes) if ((referenceId(event?.organization?.reference?.id || event?.organization?.value) === organizationId || directIds.has(referenceId(event?.id)))) {
            if (!event.id || !event.name?.value) throw new Error('Incomplete linked Event');
            matched.set(event.id, event);
          }
          if (!connection.pageInfo.hasNextPage) break;
          const next = connection.pageInfo.endCursor;
          if (!next || seenCursors.has(next)) throw new Error('Invalid Events cursor');
          seenCursors.add(next); after = next;
        }
        const today = dayInAmsterdam();
        return [...matched.values()].map(event => ({ id: event.id, name: event.name.value, url: event.onlineStoreUrl || '', image: event.image?.value || '', city: event.cityReference?.reference?.name?.value || '', date: String(event.dateStart?.value || '').slice(0, 10), group: category(event, today) })).filter(item => item.group).sort(sortEvents);
        })().catch(error => { sharedRequest = null; throw error; });
      }
      return sharedRequest;
    };
    sections.forEach(section => {
    const eventGroup = section.dataset.eventGroup || 'regular';
    const panel = section.closest('[data-f2w-fighter-panel]');
    const tab = root.querySelector(`[data-f2w-fighter-tab][data-target="${panel.id}"]`);
    const content = section.querySelector('[data-f2w-organization-event-content]');
    const status = section.querySelector('[data-f2w-organization-events-status]');
    const pagination = section.querySelector('[data-f2w-organization-event-pagination]');
    let items = [];
    let page = 1;
    let loaded = false;
    let loading = false;
    const pageSize = 24;
    const card = item => {
      const node = make(item.url ? 'a' : 'div', 'fd-event-card');
      if (item.url) node.href = item.url;
      const imageUrl = item.image || existingImages.get(normalizeUrl(item.url));
      if (imageUrl) {
        const image = make('img'); image.src = imageUrl; image.alt = item.name;
        image.width = 800; image.height = 600; image.loading = 'lazy'; node.appendChild(image);
      }
      if (item.date) {
        const date = new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${item.date}T12:00:00Z`));
        node.appendChild(make('p', 'fd-event-card__date', date));
      }
      node.appendChild(make('p', 'fd-event-card__name', item.name));
      if (item.city) node.appendChild(make('p', 'fd-event-card__location', item.city));
      return node;
    };
    const render = () => {
      const total = Math.ceil(items.length / pageSize);
      page = Math.min(Math.max(1, page), Math.max(1, total));
      const fragment = document.createDocumentFragment();
      const shown = items.slice((page - 1) * pageSize, page * pageSize);
      for (const group of ['upcoming', 'past', 'historic']) {
        const grouped = shown.filter(item => item.group === group);
        if (!grouped.length) continue;
        fragment.appendChild(make('p', 'f2w-fighter-v2__section-label', labels[group]));
        const grid = make('div', 'fd-events f2w-fighter-v2__events');
        grouped.forEach(item => grid.appendChild(card(item))); fragment.appendChild(grid);
      }
      content.replaceChildren(fragment);
      content.hidden = false;
      status.textContent = items.length ? '' : root.dataset.eventsEmpty;
      pagination.setAttribute('aria-label', root.dataset.pageLabel || '');
      pagination.hidden = total <= 1;
      const controls = [];
      const button = (text, target, label, active) => {
        const node = make('button', 'f2w-event-directory__tab', text);
        node.type = 'button'; node.setAttribute('aria-label', label);
        if (active) node.setAttribute('aria-current', 'page');
        else node.addEventListener('click', () => { page = target; render(); pagination.querySelector('[aria-current="page"]')?.focus({ preventScroll: true }); section.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        return node;
      };
      if (total > 1) {
        if (page > 1) controls.push(button('◀', page - 1, root.dataset.previousLabel));
        const pages = [...new Set([1, page - 1, page, page + 1, total].filter(value => value >= 1 && value <= total))].sort((a, b) => a - b);
        let previous = 0;
        pages.forEach(value => {
          if (value - previous > 1) controls.push(make('span', '', '…'));
          controls.push(button(counter.format(value), value, `${root.dataset.pageLabel} ${counter.format(value)}`, value === page));
          previous = value;
        });
        if (page < total) controls.push(button('▶', page + 1, root.dataset.nextLabel));
      }
      pagination.replaceChildren(...controls);
    };
    const load = async () => {
      if (loaded || loading) return;
      loading = true;
      status.textContent = root.dataset.eventsLoading;
      content.hidden = true; pagination.hidden = true;
      try {
        const allEvents = await loadEvents();
        items = eventGroup === 'all' ? allEvents : allEvents.filter(item => eventGroup === 'historic' ? item.group === 'historic' : item.group !== 'historic');
        page = 1; loaded = true; render();
      } catch (_) {
        status.textContent = root.dataset.eventsError;
        content.hidden = true;
      } finally { loading = false; }
    };
    tab?.addEventListener('click', load);
    const observer = new MutationObserver(() => { if (tab?.getAttribute('aria-selected') === 'true') load(); });
    if (tab) observer.observe(tab, { attributes: true, attributeFilter: ['aria-selected'] });
    if (tab?.getAttribute('aria-selected') === 'true') load();
    });
  });
})();






